import { app as firebaseApp } from '@/firebase'
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
} from 'firebase/firestore'

const db = getFirestore(firebaseApp)

/** Return everything from /communities with zero filtering/sorting. */
export async function listCommunitiesFS() {
  const snap = await getDocs(collection(db, 'communities'))
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

export function subscribeCommunitiesFS(onRows) {
  return onSnapshot(
    collection(db, 'communities'),
    (snap) => {
      const rows = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => {
          const aName = (
            a.communityName ||
            a.name ||
            a.code ||
            a.communityCode ||
            a.id ||
            ''
          )
            .toString()
            .toLowerCase()
          const bName = (
            b.communityName ||
            b.name ||
            b.code ||
            b.communityCode ||
            b.id ||
            ''
          )
            .toString()
            .toLowerCase()
          return aName.localeCompare(bName)
        })
      onRows(rows)
    },
    (error) => {
      console.error('[communityService] subscribeCommunitiesFS failed:', error)
      onRows([])
    }
  )
}

export async function updateCommunityFS(id, changes) {
  if (!id) throw new Error('Missing community id')
  await updateDoc(doc(db, 'communities', id), {
    ...changes,
    updatedAt: serverTimestamp(),
  })
}
